import { useCallback } from 'react';
import s, { UploadResponseStruct } from './struct';
import useApiRequest from './useApiRequest';
import getErrorName from './getErrorName';
import { sendEvent } from './analytics';

/**
 * @return {{upload: function(files: File[], onSuccess: function?, onError: function?), uploading: boolean, error: Error|null}}
 */
const useUpload = () => {
  const {
    sendApiRequest,
    processing: uploading,
    error,
  } = useApiRequest({ url: '/api/upload' });

  const upload = useCallback((files, onSuccess, onError) => {
    const formData = new FormData();

    files.forEach((file) => {
      formData.append('files[]', file, file.name);
    });

    sendApiRequest({
      data: formData,
      validateResponse(response) {
        s.assert(response.data, UploadResponseStruct);
      },
      onSuccess(response, time) {
        sendEvent({
          category: 'upload',
          action: 'success',
          label: `${time}:${files.length}`,
        });

        onSuccess?.(response.data);
      },
      onError(error, time) {
        sendEvent({
          category: 'upload',
          action: 'error',
          label: `${getErrorName(error)}:${time}:${files.length}`,
        });

        onError?.(error);
      },
    });
  }, [sendApiRequest]);

  return {
    upload,
    uploading,
    error,
  };
};

export default useUpload;
